export const DraftStatus = Object.freeze({
    EDITING: "editing",
    SUBMITTED: "submitted",
    APPROVED: "approved",
    REJECTED: "rejected",
})
